import { useMemo } from 'react';
import { useLearningEvents } from 'academy-common-lib/features/liveEvents/liveEventQueries';
import { toLiveEventCardModel } from 'academy-common-lib/features/liveEvents/toLiveEventCardModel';
import { orderEventsByWorkshopIds } from 'academy-common-lib/features/liveEvents/nextStepWorkshopIds';
const DEFAULT_PAGE_LENGTH = 12;
export const useEligibleOnboardingLiveEvents = ({
  pageLength = DEFAULT_PAGE_LENGTH,
  skip = false
} = {}) => {
  const {
    learningEvents,
    learningEventsLoading,
    learningEventsError
  } = useLearningEvents({
    pageLength
  }, {
    skip
  });
  const {
    events,
    registeredWorkshopCount
  } = useMemo(() => {
    const registeredCount = learningEvents.filter(event => event.nextRegisteredSession !== undefined).length;
    const eligibleEvents = orderEventsByWorkshopIds(learningEvents.filter(event => event.nextRegisteredSession === undefined && !event.attended)).map(toLiveEventCardModel);
    return {
      events: eligibleEvents,
      registeredWorkshopCount: registeredCount
    };
  }, [learningEvents]);
  return {
    events,
    registeredWorkshopCount,
    loading: learningEventsLoading,
    error: learningEventsError
  };
};